import React from 'react'
import LayoutModal from '../Layout/LayoutModal'
import PropTypes from 'prop-types'
import { StyleSheet } from 'aphrodite'
import { BP_XS } from '../../lib/breakpoints'
import { WIDTH } from '../../lib/helpers'

const WidgetMotionDesign = ({
  isModalOpened,
  setModalOpened,
  video,
  format,
}) => {
  let videoWidth = WIDTH <= BP_XS ? 480 : 960
  let videoHeight = WIDTH <= BP_XS ? 270 : 540

  if (format === 'square') {
    const { innerHeight } = window
    videoWidth = innerHeight * 0.75
    videoHeight = videoWidth
  }

  return (
    <LayoutModal
      onClose={() => {
        setModalOpened(false)
      }}
      isOpened={isModalOpened}
      dynamicStyle={styles.modalContainer}
      customStyle={styles.modal}
    >
      <video width={videoWidth} height={videoHeight} controls autoPlay>
        <source src={video} type="video/mp4" />
      </video>
    </LayoutModal>
  )
}

const styles = StyleSheet.create({
  modalContainer: {
    width: '100%',
  },
  modal: {
    width: '80vw',
    maxWidth: '85vw',
    display: 'flex',
    justifyContent: 'center',
  },
})

WidgetMotionDesign.propTypes = {
  isModalOpened: PropTypes.bool,
  setModalOpened: PropTypes.func,
  video: PropTypes.string.isRequired,
  format: PropTypes.string,
}

WidgetMotionDesign.defaultProps = {
  format: 'rect',
}

export default WidgetMotionDesign
